// orders modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import moment from 'moment';
import {
  ORDER_URL,
  PENDING_ORDERS_URL,
  CONSOLIDATED_ORDERS_URL,
  SALES_ORDER_URL,
  SALES_INVOICE_URL,
} from '../../api/url'

// initial state
const state = {
  orderDetails: [],
  orderTimeFrame: [],
  ordersLoading: false,
  orderModalVisible: false,
  order: null,
}

// actions
const actions = {
  //fetch order by timeframe
  fetchOrderByTimeFrame(context,timeFrame) {
    const token = getToken();
    const config = {
      method: 'get',
      url: `${ORDER_URL}${timeFrame}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    context.commit("ordersLoading")
    axios(config)
    .then(response => {
      let orderWithModifiedDate = response.data.reverse().map(Order => {
        const obj = {
          ...Order,
          OrderDate: moment(Order.OrderDate).format("MM/DD/YY"),
          DispatchDate: moment(Order.DispatchDate).format("MM/DD/YY"),
          FinalPrice: Order.FinalPrice.toFixed(2),
        }
        return obj;
      })
      context.commit('fetchOrderByTimeFrame', orderWithModifiedDate);
    })
    .catch (err => {
      console.log('fetchOrderByTimeFrame', err);
    })
  },

  fetchOrderByTimeFrameReturn(context,timeFrame) {
    const token = getToken();
    const config = {
      method: 'get',
      url: `${ORDER_URL}${timeFrame}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
   return axios(config)
  },

  //fetch order detail
  fetchOrderDetails(context,orderId) {
    const token = getToken();
    const config = {
      method: 'get',
      url: `${ORDER_URL}`,
      params: {
        pk: orderId,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
   //.then(response => {
         let OrderTime = response.data.map(Sales_Order_Line=>{
           const obj = {
             ...Sales_Order_Line,
             OrderDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
           }
           return obj;
       });
   //   context.commit('fetchOrderDetails', OrderTime);
   // }), (err => {
   //    console.log('fetchorderdetails', err);
   // })
  },
  //fetch Consolidated Orders
  fetchConsolidatedOrders(context) {
     const token = getToken();
     const config = {
       method: 'get',
       url: CONSOLIDATED_ORDERS_URL,
       headers: {
         Authorization: `JWT ${token}`,
       },
     };
     axios(config)
     .then(response => {
       context.commit('fetchConsolidatedOrders', response.data);
     }), (err => {
       console.log ('fetchConsolidatedOrders', err);
     })
  },
  fetchSODetails(context,orderId) {
    const token = getToken();
    const config = {
      method: 'get',
      url: `${SALES_ORDER_URL}`,
      params: {
        pk: orderId,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config);
  },
  fetchSIDetails(context,orderId) {
    const token = getToken();
    const config = {
      method: 'get',
      url: `${SALES_INVOICE_URL}`,
      params: {
        pk: orderId,
      },
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config);
  },
  //cancel order
  cancelOrder(context,orderId) {
    const token = getToken();
    const config = {
      method: 'put',
      url: `${ORDER_URL}/cancel/${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('cancelOrder', response.data);
    }), (err => {
      console.log ('cancelordererror', err);
    })
  },
}
// mutations
const mutations = {
  fetchOrderDetails(state, payload) {
    state.orderDetails = payload
    //console.log("orderDetails",payload);
  },
  fetchOrderByTimeFrame(state, payload) {
    state.orderTimeFrame = payload;
    state.ordersLoading = false;
  },
  ordersLoading(state, payload) {
    state.ordersLoading = true;
  },
  toggleOrderModal(state, payload) {
    state.orderModalVisible = payload;
  },
  setOrderId(state, payload) {
    state.order = payload;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js